<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <!-- HEADER SECTION -->
    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">ACCESS MANAGEMENT</h4>

      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :options="options_search"
          :error-required="false"
          placeholder="Filter By"
          class="m__r--5"/>
        <b-form-input
          ref="filterInput"
          v-model="filter_data"
          placeholder="Search"
          style="width: 250px; height: 35px"/>
      </b-form>
    </div>

    <!-- CONTENT SECTION -->
    <div class="studio-page-content">
      <div class="table-column">
        <v-client-table
          v-if="!load_first"
          ref="accessTableComponent"
          :columns="columns"
          :options="option"
          :data="data_table"
          class="jTable table-access-application"
          @row-click="openDetail">

          <div
            slot="logo"
            slot-scope="props">
            <img
              :src="props.row.icon"
              width="30">
          </div>

          <div
            slot="created_at"
            slot-scope="props">
            {{ convertDateTime(props.row.created_at) }}
          </div>

          <div
            slot="updated_at"
            slot-scope="props">
            {{ convertDateTime(props.row.updated_at) }}
          </div>

        </v-client-table>
        <jLoadingTable v-if="load_first"/>
      </div>
    </div>

    <b-popover
      ref="searchFormModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="targetSearch"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>
  </div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies, no-nested-ternary, max-len, no-unused-vars, no-console */
import { mapActions, mapState } from 'vuex';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
// import jApiSetting from '@/services/jApiSetting';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      popoverSearchShow: false,
      load_first: true,
      filter_data: '',
      select_type: 'name',
      data_table: [],
      options_search: [
        {
          text: 'Id',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'name',
        },
      ],
      columns: ['id', 'logo', 'name', 'total_page', 'created_at', 'updated_at'],
      option: {
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['applications_list', 'is_sidebar_minimized']),
  },
  watch: {
    // eslint-disable-next-line
    'applications_list': function() {
      this.data_table = this.applications_list;
      this.load_first = false;
    },
  },
  created() {
    this.getApplicationList();
  },
  mounted() {
    this.$refs.filterInput.focus();
  },
  methods: {
    ...mapActions('jStoreSetting', ['actionGetApplicationsList']),

    getApplicationList() {
      const parameter = {
        page: 1,
        limit: 1000,
        column: 'updated_at',
        sort: 'desc',
      };
      this.actionGetApplicationsList({ params: parameter });
    },
    openDetail(data) {
      this.$router.push(`/access-application/detail/${data.row.id}`);
    },
    filter(val) {
      if (this.select_type === 'name') {
        this.data_table = this.applications_list.filter(app =>
          app.name.toUpperCase().includes(val.toUpperCase()));
      } else if (this.select_type === 'id') {
        this.data_table = this.applications_list.filter(app =>
          String(app.id).toUpperCase().includes(val.toUpperCase()));
      }
    },
    convertDateTime(data) {
      if (data) {
        const date = new Date(data);
        const years = date.getFullYear();
        const mounth = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const dates = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();

        return `${years}-${mounth}-${dates} ${hours}:${minutes}`;
      }
      return null;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/access/jAccessApplicationList.vue